import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { UICreatorService } from '@iupics-manager/managers/ui-creator/ui-creator.service';
import { IupicsWidget } from '@iupics-manager/models/iupics-widget';
import { AbstractWidgetComponent } from '@iupics/modules/iupics-widgets/abstract-widget.component';
import { WidgetStateComponent } from '../widget-state/widget-state.component';

/** web addresses only: anything else (javascript:, data:...) would run in the application */
const WEB_ADDRESS = /^https?:\/\/\S+$/i;

@Component({
  selector: 'iu-metabase-widget',
  standalone: true,
  imports: [WidgetStateComponent],
  templateUrl: './metabase-widget.component.html',
  styleUrl: './metabase-widget.component.scss',
})
export class MetabaseWidgetComponent extends AbstractWidgetComponent implements OnInit {
  url: SafeUrl;

  constructor(
    private sanitize: DomSanitizer,
    protected uiCreator: UICreatorService
  ) {
    super(uiCreator);
  }

  ngOnInit(): void {
    if (!this.url) {
      this.updateWidget();
    }
  }

  updateWidget(): void {
    const address = this.widget?.iframe?.trim() ?? '';
    this.loadError = !!address && !WEB_ADDRESS.test(address);
    if (!address || this.loadError) {
      this.url = null;
      this.isLoading = false;
      return;
    }
    this.isLoading = true;
    this.url = this.sanitize.bypassSecurityTrustResourceUrl(address);
  }

  onFrameLoad(): void {
    this.isLoading = false;
    this.markUpdated();
  }

  /** nothing drawn from colours or format */
  override applyPresentation(widget: IupicsWidget): void {
    this.setPresentation(widget);
  }
}
